import * as React from "react";
import { connect } from "react-redux";
import * as redux from "redux";
import { Paths } from "../../constants";
import { TreeBranch } from "../../models/navigation";
import { AppState } from "../../store";
import * as AuthHelper from "../../utils/AuthHelper";
import { IconLink } from "../generic";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    currentNavBranch: state.nav.branches.find((b) => b !== undefined && b.url === state.nav.currentPath),
    isAdminUser: AuthHelper.isAdminUser(state.auth.accessToken, state.auth.refreshToken),
    isLoggedIn: (state.auth.data)
        ? state.auth.data.hasUserRecord
        : false,
    isOnAdminPage: (state.router.location)
        ? state.router.location.pathname.indexOf("/admin") === 0
        : false,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({

});

interface OwnProps {
}

interface ConnectedState {
    currentNavBranch?: TreeBranch;
    isAdminUser: boolean;
    isLoggedIn: boolean;
    isOnAdminPage: boolean;
}

interface ConnectedDispatch {
}

interface OwnState {}
export class AdminRibbonComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    public render() {
        if (!this.props.isAdminUser || !this.props.isLoggedIn)
            return null;

        let adminLink = null;
        let liveSiteLink = null;
        if (this.props.isOnAdminPage)
            liveSiteLink = <li><IconLink to={Paths.Home} icon="home" label="Live site" /></li>;
        else
            adminLink = <li><IconLink to={Paths.Admin.Landing} icon="wrench" label="Admin" /></li>;

        let navEditLink = null;
        if (this.props.currentNavBranch && this.props.currentNavBranch.url !== "/") {
            navEditLink = <li><IconLink to={Paths.AdminNav.List + "/edit/" + this.props.currentNavBranch.id} icon="location-arrow" label="Edit Nav" /></li>;
        }

        return <div id="admin">
            <div className="ribbon">

                <ul className="content-main tools">
                    {navEditLink}
                    {/* @if (Model.RecordContext != null)
                    {
                        if (Model.RecordContext.EditLink != null)
                        {
                            <li><a href="@Model.RecordContext.EditLink"><i className="fa fa-pencil"></i>Edit</a></li>
                        }
                    } */}

                    {/* @if (Model.LoggedInAsUser != null)
                    {
                        <li>
                            <p>
                                Logged in as <strong>@Html.Raw(Model.LoggedInAsUser.FullName)</strong>
                                <br /><small>@(Html.ActionLink<AccountController>(x => x.LogoutSecondaryUser(), "Switch back to " + Model.PrincipalUser.FullName))</small>
                            </p>
                        </li>
                    } */}

                </ul>

                <ul className="content-sub tools">
                    <li><IconLink to={Paths.Account.Logout} icon="sign-out" label="Sign out" /></li>
                    {adminLink}
                    {liveSiteLink}
                </ul>

                <div className="clear"></div>
            </div>
        </div>;
    }
}

export const AdminRibbon: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(AdminRibbonComponent);



// WEBPACK FOOTER //
// ./src/components/admin/AdminRibbon.tsx